<template>
<div class="token">
     <div class="alert alert-success" role="alert">
        <strong><span class="alert-heading">Las APIs V1 sólo tendrán soporte hasta 28-02-2022 y se darán de baja el 30-06-2022, no aplica para API V1 de CRM</span></strong> <br>
        <span>En el siguiente enlace se encuentra la tabla de equivalencias de APIs versión 1.0 y versión 2.0 <a href="https://docs.google.com/spreadsheets/d/13nSRv1WXPJ4IUPdOmYXnKfoDOTpv4zse/edit#gid=727860265" class="alert-link" target="_blank">Click aquí!</a></span> <br>
        <span class="mb-0">Ahora está disponible una versión mejorada de las APIs de Wolkvox - Versión 2.0, con más estandarización. <a href="https://www.wolkvox.com/apis-v2/" class="alert-link" target="_blank">Ver más...</a></span>
    </div>
  <h1>TOKEN</h1>
  <p>
    wolkvox cuenta con múltiples APIs que permiten realizar integraciones con aplicaciones o procesos externos como CRM, ERP y Business Inteligence. Usando links seguros HTTPS que consta de varias funciones y parámetros que se reciben vía GET.
  </p>
  <div class="content">
    <img class="token" src="@/assets/API2.png" alt="Creacion Token Manager Wolkvox">
    <div>
      <h3>CREACIÓN DEL TOKEN</h3>
      <p>Para crear el token se debe ingresar al Manager Wolkvox en la parte de Configuración. Luego nos vamos para integraciones y creamos el token, colocando un nombre y presionando el botón add token y lo usamos en nuestros links de integración.</p>
    </div>
  </div>
  <div>
    <h3>OBJETIVO</h3>
    <p>
      El objetivo de este documento es mostrar cómo pueden realizarse integraciones desde aplicaciones externas o procesos al módulo de campañas de wolkvox.
    </p>
    <h3>TECNOLOGÍA</h3>
    <p>
      La tecnología usada es un link seguro https que consta de varias funciones y parámetros que se reciben via get.
    </p>
  </div>
</div>  
</template>

<script>
export default {
  name: "token"
}
</script>

<style>
.token{
  width: 100%;
  margin: auto;
}
.token h1{
  text-align: center;
}
.token h3,
.token h1{
  color: #ff9917;
  margin-top: 20px;
  font-weight: bold;
  margin-left: 10%;
  margin-right: 10%;
}
.token p {
  font-size: 1.2rem;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 10%;
  margin-right: 10%;
}

.content{
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  background-color: #061a40;
  justify-content: center;
  align-items: center;
  margin: 10px 15px;
  border:2px solid black;
  border-radius: 10px;
  padding: 15px;
  margin-left: 10%;
  margin-right: 10%;
}
.content p{
  color: white;
}
img.token{
  width: 500px;
  height: 300px;
  border-radius: 10px;
}


</style>
